<template>
  <nav class="breadcrumbs" aria-label="Breadcrumbs">
    <h2></h2>
    <ul>
      <li><a href="/">{{subDomain}} <span v-if="nestedLoc">&#8250;</span></a>
      </li><li v-for="(loc, index) in nestedLoc" :key="index">
        <router-link v-if="index != Object.keys(nestedLoc).length - 1" :to="{path: loc.route}">{{loc.routeName}} <span>&#8250;</span></router-link>
        <span v-else class="lastCrumb">{{loc.routeName}}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'breadcrumbs',
  data () {
    return {
    }
  },
  props: [
    'subDomain',
    'nestedLoc'
  ]
}
</script>

<style lang="less" scoped>
  @import '../../less/elements/color.less';
  @import '../../less/elements/typography.less';
  .breadcrumbs{
    color: @color-text;
    li{
      display: inline-block;
    }
    a,
    .lastCrumb{
      color: @color-text;
      font-size: 15px;
      line-height: 27px;
      .font-family();
      span{
        font-size: 27px;
        line-height: 15px;
        vertical-align: text-top;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/foundation/breadcrumbs.vue